import React from "react";

import { styled, Avatar, Divider } from "@mui/material";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";

import { useLocation } from "react-router";
import HelpPopup from "../HelpPopup";
import SidebarBrand from "./SidebarBrand/sidebar-brand";
import { SidebarDrawer } from "./sidebar";

export const SIDEBAR_WIDTH: number = 200;
export const SIDEBAR_WIDTH_CLOSED: number = 68;

const SidebarFooter = styled("div")(() => ({
  marginTop: "auto",
}));

interface SidebarUnauthProps {
  minified?: boolean;
  open: boolean;
  onUpdate: (open: boolean) => void;
  platformId?: number;
}

const SidebarUnauth: React.FC<SidebarUnauthProps> = ({ open, onUpdate, minified = false, platformId }) => {
  const { pathname } = useLocation();
  const [helpPopupAnchorEl, setHelpPopupAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleHelpClick: React.MouseEventHandler<HTMLElement> = (e) => {
    e.stopPropagation();
    setHelpPopupAnchorEl(e.currentTarget);
  };

  const onClosePopup = () => {
    setHelpPopupAnchorEl(null);
  };

  return (
    <SidebarDrawer variant="permanent" open={open}>
      <SidebarBrand minified={minified} drawerOpen={open} platformId={platformId} />

      <SidebarFooter>
        {helpPopupAnchorEl && (
          <HelpPopup visible={Boolean(helpPopupAnchorEl)} onClose={onClosePopup} anchorEl={helpPopupAnchorEl} />
        )}

        {/*<Divider />
        <Avatar onClick={handleHelpClick} sx={{ bgcolor: "info.main", width: 36, height: 36, m: 2, cursor: "pointer" }}>
          <HeadsetMicOutlinedIcon sx={{ width: 20, height: 20 }} />
        </Avatar>*/}
      </SidebarFooter>
    </SidebarDrawer>
  );
};

export default SidebarUnauth;
